import { render, staticRenderFns } from "./BuyTapFree.vue?vue&type=template&id=fbb13f2e&scoped=true&"
import script from "./BuyTapFree.vue?vue&type=script&lang=js&"
export * from "./BuyTapFree.vue?vue&type=script&lang=js&"
import style0 from "./BuyTapFree.vue?vue&type=style&index=0&id=fbb13f2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb13f2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbb13f2e')) {
      api.createRecord('fbb13f2e', component.options)
    } else {
      api.reload('fbb13f2e', component.options)
    }
    module.hot.accept("./BuyTapFree.vue?vue&type=template&id=fbb13f2e&scoped=true&", function () {
      api.rerender('fbb13f2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page_price_versions/components/Buy/BuyTapFree.vue"
export default component.exports